import React from "react";
import styles from "./FixedButtons.module.css";
import phoneIcon from "../../asset/fixed-buttons/phone-white.webp";
import lockIcon from "../../asset/container/book-free-tour/lock.webp";
import { useLocation, useNavigate } from "react-router-dom";
import { trackCall } from "../../utils/utils";
import { useContactDetails } from "../../contexts/contact-context";
const FixedButtons = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { phone } = useContactDetails();
  return (
    <div className={styles.fixed}>
      <div className={styles.upper}>
        <img src={lockIcon} alt="lock" />
        <p>
          By clicking the button below, you agree to our Terms of Service and
          acknowledge our Privacy Policy.
        </p>
      </div>
      <div className={styles.lower}>
        <button
          className={styles.free}
          onClick={() => navigate("/locations")}
        >
          Book a free tour
        </button>
        <a href={`tel:${phone}`} onClick={() => trackCall(pathname)}>
          <button className={styles.connect}>
            <img src={phoneIcon} alt="phone" /> Connect now
          </button>
        </a>
      </div>
    </div>
  );
};

// FixedButtons.defaultProps = {
//   phone: "8287999888",
// };

export default FixedButtons;
